<template>
<!-- eslint-disable max-len -->
<list-page
  name="Metric"
  use="_id"
  :display="display"
  page-prefix="/blade/metrics"
  :fetch="getMetrics"
  :remove="deleteMetric"
></list-page>
</template>

<script>
import { mapActions } from 'vuex';

import ListPage from '../../ui/pages/ListPage';

export default {
  components: {
    ListPage
  },
  methods: {
    ...mapActions([
      'getMetrics',
      'deleteMetric',
    ]),
    display({ name: metricName, type, percentage, min, max, hidden, updated }) {
      const date = updated && new Date(updated);
      const dateString = date && `(edited ${date.toLocaleDateString()} ${date.toLocaleTimeString()})` || '';
      return `${metricName} (${type} / ${hidden ? 'hidden' : 'visible'}${percentage ? ' / percentage' : ''}${min !== undefined || max !== undefined ? ` / [${min !== undefined ? min : percentage ? 0 : '-inf'}, ${max !== undefined ? max : percentage ? 100 : '+inf'}]` : ''}) ${dateString}`;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/MetricsList.vue